/**
 * Applies persisted shadcn theme tokens (including `.dark`) as early as
 * possible so MUI dialogs/pages don't flash light mode on first paint.
 * Also applies REACT_APP_PRIMARY_COLOR from env when set.
 */
import React, { useLayoutEffect } from 'react';
import { useThemeConfig } from '../../hooks/use-theme-config';
import { env } from '../../config/env';
import { hexToHsl } from '../../utils/color';

export const ThemeBootstrap: React.FC = () => {
  useThemeConfig();

  useLayoutEffect(() => {
    if (!env.primaryColor) {
      return;
    }
    const hsl = hexToHsl(env.primaryColor);
    if (!hsl) {
      return;
    }
    document.documentElement.style.setProperty('--primary', hsl);
  }, []);

  return null;
};
